export default __webpack_public_path__ + "static/media/International_artwork_selling-small.b48cf72b.jpeg";